import React, { useState, useEffect } from "react";
import config from "../../api/config";
import { IoIosCloseCircleOutline } from "react-icons/io";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { setToast } from "../../redux/actions/ToastAction";
import { useDispatch } from "react-redux";
import { IconButton } from "@mui/material";

const TariffCreator = ({ tariff, modal, setModal, refresh }) => {
  const [name, setName] = useState("");
  const [countKey, setCountKey] = useState(0);
  const [countDay, setCountDay] = useState(30);
  const [price, setPrice] = useState(0);

  const dispatch = useDispatch();
  useEffect(() => {
    if (tariff) {
      setCountKey(tariff.countKey);
      setCountDay(tariff.countDay);
      setPrice(tariff.price);
      setName(tariff.name);
    }
  }, [tariff]);

  // submit
  const handleSubmit = async () => {
    let sub = {
      active: true,
      countDay: countDay,
      countKey: countKey,
      name: name,
      price: price,
    };
    if (tariff) sub.id = tariff.id;
    try {
      await config.post(`/api/advertisingTariff/v1/saveOrEdit`, sub);
      setCountKey(0);
      setCountDay(0);
      setPrice(0);
      setName("");
      setModal(false);
      dispatch(setToast(true, "success", "Успешно опубликовано"));
      refresh(true);
    } catch (e) {
      console.error(e?.message);
    }
  };
  return (
    <div>
      <Dialog
        open={modal}
        onClose={() => {
          setModal(false);
          setCountKey(0);
          setCountDay(0);
          setPrice(0);
          setName("");
          setModal(false);
          refresh(true);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="d-flex justify-content-between align-items-center px-5"
        >
          <h3>{tariff ? tariff.name : "Создать новый тариф"}</h3>
          <IconButton onClick={() => setModal(false)}>
            <IoIosCloseCircleOutline />
          </IconButton>
        </DialogTitle>

        {/* <DialogContentText id="alert-dialog-description">

          </DialogContentText> */}
        <DialogContent>
          <label htmlFor="name">Имя</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <br />
          <label htmlFor="countKey">Ключевые слова</label>
          <input
            type="number"
            id="countKey"
            value={countKey}
            onChange={(e) => setCountKey(e.target.value)}
          />
          <br />
          <label htmlFor="countDay">Период (дни)</label>
          <input
            type="number"
            id="countDay"
            value={countDay}
            onChange={(e) => setCountDay(e.target.value)}
          />
          <br />
          <label htmlFor="price">Цена</label>
          <input
            type="number"
            id="price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          <br />
          <DialogActions>
            <Button onClick={handleSubmit} variant="contained">
              Сохранить
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TariffCreator;
